import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
  {
    path: "/",
    meta: {
      'title': '汽车时间_属于你的汽车时间_motortime.com',
      'keepAlive': true,
      // 'keywords':'汽车,汽车时间,汽车网,富士范儿,VTEC范儿,华系范儿,波子范儿,凌志范儿,汽车报价,汽车图片,视频,评测,社区,兴趣号,商城',
      'description':'汽车时间，提供汽车行业有特色的新闻资讯、汽车图片、要闻推送；同时，还有线下车友活动组织、线上汽车商品促销信息，满足您对汽车资讯需要。'
    },
    name: "Home",
    component: () => import("./views/Home.vue")
  },
  {
    path: "/homedemo",
    meta: {
      'title': '汽车时间_属于你的汽车时间_motortime.com',
      'keepAlive': true,
      // 'keywords':'汽车,汽车时间,汽车网,富士范儿,VTEC范儿,华系范儿,波子范儿,凌志范儿,汽车报价,汽车图片,视频,评测,社区,兴趣号,商城',
      'description':'汽车时间，提供汽车行业有特色的新闻资讯、汽车图片、要闻推送；同时，还有线下车友活动组织、线上汽车商品促销信息，满足您对汽车资讯需要。'
    },
    name: "HomeDemo",
    component: () => import("./views/homeDemo.vue")
  },
  {
    path: "/secondarypage/:id",
    meta: {
      'title': '列表',
      'keepAlive': true
    },
    name: "SecondaryPage",
    component: () => import("./views/SecondaryPage.vue")
  },
  {
    path: "/article/:id/details",
    meta: {
      'title': '资讯详情',
      'keepAlive': true,
      'keywords':'',
      'description':''
    },
    name: "Details",
    component: () => import("./views/Details.vue")
  },
  {
    path: "/article/:id/post",
    meta: {
      'title': '资讯详情',
      'keepAlive': true,
      'keywords':'',
      'description':''
    },
    name: "PostDetails",
    component: () => import("./views/PostDetails.vue")
  },
  {
    path: "/cartoonindex",
    meta: {
      'title': '动漫列表',
      'keepAlive': true
    },
    name: "CartoonIndexList",
    component: () => import("./views/CartoonIndexList.vue")
  },
  {
    path: "/videolist",
    meta: {
      'title': '视频列表',
      'keepAlive': true
    },
    name: "VideoList",
    component: () => import("./views/VideoList.vue")
  },
  {
    path: "/active",
    meta: {
      'title': '活动',
      'keepAlive': true
    },
    name: "Active",
    component: () => import("./views/Active.vue")
  },
  {
    path: "/videolists",
    meta: {
      'title': '视频列表',
      'keepAlive': true
    },
    name: "VideoLists",
    component: () => import("./views/VideoLists.vue")
  },
  
  {
    path: "/article/:id/video",
    meta: {
      'title': '视频详情',
      'keepAlive': true
    },
    name: "VideoDetails",
    component: () => import("./views/VideoDetails.vue")
  },
  {
    path: "/videodemo/:id",
    meta: {
      'title': '视频',
      'keepAlive': true
    },
    name: "VideoDemo",
    component: () => import("./views/VideoDemo.vue")
  },
  {
    path: "/article/:id/pic",
    meta: {
      'title': '图片详情',
      'keepAlive': true
    },
    name: "PicDetails",
    component: () => import("./views/PicDetails.vue")
  },
  {
    path: "/index/index/information_info/id/:id",
    meta: {
      'title': '详情',
      'keepAlive': true
    },
    name: "Post",
    component: () => import("./views/Post.vue")
  },
  {
    path: "/detail-:id.html",
    meta: {
      'title': '详情',
      'keepAlive': true
    },
    name: "OldPostDetail",
    component: () => import("./views/PostDetails.vue")
  },
  {
    path: "/bbs/:id",
    meta: {
      'title': '帖子详情',
      'keepAlive': true
    },
    name: "BbsDetails",
    component: () => import("./views/BbsDetails.vue")
  },
  {
    path: "/livelist/:id",
    meta: {
      'title': '直播',
      'keepAlive': true
    },
    name: "LiveList",
    component: () => import("./views/LiveList.vue")
  },
  {
    path: "/livelistnew/:id",
    meta: {
      'title': '直播',
      'keepAlive': true
    },
    name: "LiveListNew",
    component: () => import("./views/LiveListNew.vue")
  },
  {
    path: "/live/:id",
    meta: {
      'title': '直播详情',
      'keepAlive': true
    },
    name: "LiveDetails",
    component: () => import("./views/LiveDetails.vue")
  },
  {
    path: "/livenew/:id",
    meta: {
      'title': '直播详情',
      'keepAlive': true
    },
    name: "LiveDetailsNew",
    component: () => import("./views/LiveDetailsNew.vue")
  },
  {
    path: "/aboutus",
    meta: {
      'title': '关于我们',
      'keepAlive': true
    },
    name: "AboutUs",
    component: () => import("./views/AboutUs.vue")
  },
  {
    path: "/joinus",
    meta: {
      'title': '加入我们',
      'keepAlive': true
    },
    name: "JoinUs",
    component: () => import("./views/JoinUs.vue")
  },
  {
    path: "/linkus",
    meta: {
      'title': '联系我们',
      'keepAlive': true
    },
    name: "LinkUs",
    component: () => import("./views/LinkUs.vue")
  },
  {
    path: "/anime",
    meta: {
      'title': '动漫表情',
      'keepAlive': true
    },
    name: "Anime",
    component: () => import("./views/Anime.vue")
  },
  {
    path: "/report/:id",
    meta: {
      'title': '行业报告',
      'keepAlive': true
    },
    name: "Report",
    component: () => import("./views/Report.vue")
  },
  {
    path: "/reportinfo/:id",
    meta: {
      'title': '报告详情',
      'keepAlive': true
    },
    name: "ReportInfo",
    component: () => import("./views/ReportInfo.vue")
  },{
    path: "/customerservice",
    meta: {
      'title': '用户服务条款',
      'keepAlive': true
    },
    name: "CustomerService",
    component: () => import("./views/CustomerService.vue")
  },{
    path: "/dispute",
    meta: {
      'title': '用户纠纷处理办法',
      'keepAlive': false
    },
    name: "Dispute",
    component: () => import("./views/Dispute.vue")
  },{
    path: "/register",
    meta: {
      'title': '用户注册协议',
      'keepAlive': true
    },
    name: "Register",
    component: () => import("./views/Register.vue")
  },{
    path: "/complaint",
    meta: {
      'title': '版权保护投诉指引',
      'keepAlive': false
    },
    name: "Complaint",
    component: () => import("./views/Complaint.vue")
  },{
    path: "/tutelage",
    meta: {
      'title': '家长监护',
      'keepAlive': true
    },
    name: "Tutelage",
    component: () => import("./views/Tutelage.vue")
  },{
    path: "/privacy",
    meta: {
      'title': '隐私协议',
      'keepAlive': false
    },
    name: "Privacy",
    component: () => import("./views/Privacy.vue")
  },{
    path: "/pay",
    meta: {
      'title': '支付',
      'keepAlive': false
    },
    name: "Pay",
    component: () => import("./views/Pay.vue")
  },{
    path: "/giftlist/:id",
    meta: {
      'title': '2021斯巴鲁粉丝嘉年华  抽奖',
      'keepAlive': true,
      'keywords':'2021斯巴鲁粉丝嘉年华  抽奖',
      'description':'2021斯巴鲁粉丝嘉年华  抽奖'
    },
    name: "Giftlist",
    component: () => import("./views/Giftlist.vue")
  },{
    path: "/lottery",
    meta: {
      'title': '2021斯巴鲁粉丝嘉年华  抽奖',
      'keepAlive': true,
      'keywords':'2021斯巴鲁粉丝嘉年华  抽奖',
      'description':'2021斯巴鲁粉丝嘉年华  抽奖'
    },
    name: "Lottery",
    component: () => import("./views/Lottery.vue")
  },{
    path: "/winnerlist/:id",
    meta: {
      'title': '2021斯巴鲁粉丝嘉年华  抽奖',
      'keepAlive': true,
      'keywords':'2021斯巴鲁粉丝嘉年华  抽奖',
      'description':'2021斯巴鲁粉丝嘉年华  抽奖'
    },
    name: "Winnerlist",
    component: () => import("./views/Winnerlist.vue")
  },{
    path: "/lotterytest",
    meta: {
      'title': '2021斯巴鲁粉丝嘉年华  抽奖测试',
      'keepAlive': true,
      'keywords':'2021斯巴鲁粉丝嘉年华  抽奖测试',
      'description':'2021斯巴鲁粉丝嘉年华  抽奖测试'
    },
    name: "Lotterytest",
    component: () => import("./views/LotteryTest.vue")
  },
  {
    path: "/subaru/aboutus",
    meta: {
      'title': '关于我们',
      'keepAlive': true
    },
    name: "SubaruAboutUs",
    component: () => import("./views/SubaruAboutus.vue")
  },{
    path: "/articlelist/:id",
    meta: {
      'title': '',
      'keepAlive': true
    },
    name: "ArticleList",
    component: () => import("./views/ArticleList.vue")
  },{
    path: "/cartoonlist",
    meta: {
      'title': '动漫列表',
      'keepAlive': true
    },
    name: "CartoonList",
    component: () => import("./views/CartoonList.vue")
  },{
    path: "/cartooninfo/:id",
    meta: {
      'title': '动漫详情',
      'keepAlive': true
    },
    name: "CartoonInfo",
    component: () => import("./views/CartoonInfo.vue")
  },
  
  {
    path: "/cartoonindexinfo/:id",
    meta: {
      'title': '动漫详情',
      'keepAlive': true
    },
    name: "CartoonIndexInfo",
    component: () => import("./views/CartoonIndexInfo.vue")
  },
  {
    path: "/404",
    meta: {
      'title': '404',
      'keepAlive': true
    },
    name: "Error",
    component: () => import("./views/Error.vue")
  },
  {
    path: "/draw",
    meta: {
      'title': '抽奖',
      'keepAlive': true
    },
    name: "Draw",
    component: () => import("./views/Draw.vue")
  },
  // {
  //   path: '*',
  //   redirect: '/404'
  // }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js